<glxy-page [isLoading]="isLoading()">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [useHistory]="true"></glxy-page-nav-button>
    </glxy-page-nav>

    <glxy-page-title>{{ 'INBOX.SETTINGS.WEBCHAT_CONFIGURATION' | translate }}</glxy-page-title>

    <glxy-page-actions>
      <mat-slide-toggle
        [formControl]="enabledCtrl"
        [tooltipPositions]="TOOLTIP_BOTTOMRIGHT"
        glxyTooltip="INBOX.WEBCHAT.SETTINGS.ENABLED_DESCRIPTION"
        highContrast="false"
        (toggleChange)="handleEnable()"
      >
        {{ (enabledCtrl.value ? 'INBOX.WEBCHAT.SETTINGS.ENABLED' : 'INBOX.WEBCHAT.SETTINGS.DISABLED') | translate }}
      </mat-slide-toggle>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper [widthPreset]="isBusinessApp ? 'full' : 'narrow'">
    @if (!!error()) {
      <ng-container
        [ngTemplateOutlet]="errorTemplate"
        [ngTemplateOutletContext]="{ errorMessage: error() }"
      ></ng-container>
    }

    @if (!!webchat()) {
      <inbox-webchat-form
        [webChatForm]="webChatForm"
        [knowledgeForm]="knowledgeForm"
        [associatedAssistant]="associatedAssistant()"
        [backUrl]="backUrl"
        (submitting)="savingWebChat($event)"
      >
        @if (showInstallInstructions()) {
          <inbox-web-chat-instructions
            [widgetId]="webchat()?.widgetId || ''"
            [widgetNamespace]="webchat()?.namespace || ''"
          ></inbox-web-chat-instructions>
        }
        @if (showUpgradeCTA()) {
          <inbox-pro-cta></inbox-pro-cta>
        }
      </inbox-webchat-form>
    }
  </glxy-page-wrapper>
</glxy-page>

<ng-template #errorTemplate let-errorMessage="errorMessage">
  <glxy-alert type="error">
    <strong>{{ 'INBOX.WEBCHAT.SETTINGS.SOMETHING_WENT_WRONG' | translate }}</strong>
    <glxy-alert-extended>
      {{ errorMessage }}
    </glxy-alert-extended>
  </glxy-alert>
</ng-template>
